import {
 FETCHED_PRICE,
} from '../actions/types';
import axios from 'axios'

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

async function convertBalance(tokenName){
  let toSymbol = "USD";
  var token = tokenName
  let url = "https://api.coingecko.com/api/v3/simple/price?ids=" + token + "&vs_currencies=" + toSymbol + "&include_market_cap=false&include_24hr_vol=false&include_24hr_change=false&include_last_updated_at=false"
  let call =  await axios.get(url,{params:{cors:true}});
  return call.data[token] ? call.data[token].usd : 0
}

async function getSupply(tokenName){
  let toSymbol = "USD";
  var token = tokenName
  let url = "https://api.coinranking.com/v1/public/coin/" + token;
  let call =  await axios.get(url,{params:{cors:true}});
}

export const initPrices = async (dispatch) => {
  let map = {'bitcoin': 'btc', 'ethereum':'eth', 'neo': 'neo','waves':'wav','lisk':'lsk','dai':'dai', 'tether':'usdt'}
  Object.keys(map).map(async (key)=>{
    let price = await convertBalance(key)
    // await getSupply(map[key])
    dispatch({type:FETCHED_PRICE,payload:{type:map[key],price}})
  })
}
